import { NgModule } from '@angular/core';
import { WebhooksEventsComponent } from './webhooks-events.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import {WEBHOOKS_EVENTS_ROUTES} from './webhooks-events.routes';
import {WebhookEventsListComponent} from './webhook-events-list/webhook-events-list.component';
import {WebhookEventsDetailsComponent} from './webhook-events-details/webhook-events-details.component';
import {WebhookSubscriptionsComponent} from './webhook-subscriptions/webhook-subscriptions.component';
import {WebhookDocumentationComponent} from './webhook-documentation/webhook-documentation.component';
import {CommonModule} from '@angular/common';
import {WebhookSubscriptionService} from './shared/webhook-subscription.service';
import {WebhookEventService} from './shared/webhook-event.service';
import {WebhookEventStatusComponent} from './webhook-event-status/webhook-event-status.component';
import {WebhookEventTypeComponent} from './webhook-event-type/webhook-event-type.component';
import {WebhookPendingSubscriptionChangesGuard} from './guards/webhook-pending-subscription-changes.guard';
import {WebhookEventHistoryStatusComponent} from './webhook-event-history-status/webhook-event-history-status.component';
import {StickyNavModule} from "ng2-sticky-nav";

@NgModule({
  imports: [
    RouterModule.forChild(WEBHOOKS_EVENTS_ROUTES),
    SharedModule,
    StickyNavModule,
  ],
  declarations: [
    WebhooksEventsComponent,
    WebhookEventsListComponent,
    WebhookEventsDetailsComponent,
    WebhookSubscriptionsComponent,
    WebhookDocumentationComponent,
    WebhookEventStatusComponent,
    WebhookEventTypeComponent,
    WebhookEventHistoryStatusComponent
  ],
  providers: [
    WebhookSubscriptionService,
    WebhookEventService,
    WebhookPendingSubscriptionChangesGuard
  ]
})
export class WebhooksEventsModule {
}
